// extracted by mini-css-extract-plugin
module.exports = {"btn":"w_p p_rc p_qT h_fm h_fB h_fq h_hc","full":"w_sx h_dm h_dx"};